import React, { useEffect, useState } from "react";

import {
    View,
    Text,
    TouchableOpacity,
    Platform
} from "react-native";
import AppTheme from "../../../shared/utils/Theme";

import { replaceCustomVariablesInString } from "../../../shared/utils/StringUtils.js";
import CategoryHomeStyle from "../../../shared/styles/categories/CategoryHomeStyle";
import Style from "../../../shared/utils/Style";
import { pop } from "../../utils/Navigation/Navigation";
import { useNavigate } from "react-router-dom";
import i18n, { getLanguage } from "../../../shared/utils/Localization/Localization";
import TipsButton from "../../../shared/components/TipsButton/TipsButton";
import LevelsButton from "../../../shared/components/LevelsButton/LevelsButtons";
import SVGIconButton from "../../../shared/designSystem/Buttons/SVGIconButton";
import { IcBack } from "../../../shared/utils/Icons";
import User from "../../../shared/data/user/User";
import { EventRegister } from "../../../shared/utils/EventListeners";
import { EventFiltersByLevelChanged } from "../../../shared/utils/Constants";

interface NavBarProps {
    sectionkey: any;
    categoryColors: { btn: string; header_bg: string; nav: string; txt: string; };
    title: string;
    tips?: any;
    showLevel?: boolean;
}

const NavBar = (props: NavBarProps) => {

    const { sectionkey, tips, title, categoryColors, showLevel = true } = props;
    const appTheme: AppTheme = new AppTheme();
    const user: User = User.getInstance();

    const categoryHomeStyle: CategoryHomeStyle = new CategoryHomeStyle();

    const [refresh, setRefresh] = useState<number>(0);

    const clr = categoryColors;
    let navBarColor: string = clr.nav;
    let textColor: string = clr.txt;

    let titleToDisplay = replaceCustomVariablesInString(title);

    useEffect(() => {
        EventRegister.addEventListener(EventFiltersByLevelChanged, (data) => {
            setRefresh(new Date().getTime());
        });
        return () => {
            EventRegister.removeEventListener(EventFiltersByLevelChanged);
        };
    }, []);

    const navigate = useNavigate();

    const goBack = () => {
        pop({ componentId: "", navigate });
    }

    const getLeftButton = () => {
        return <SVGIconButton buttonSize={appTheme.pixelPerfect(30)} Icon={IcBack} onPress={goBack} color={"#354F84"} />
    }

    const renderTitle = () => {
        const levelTitle: React.JSX.Element = showLevel === false ? <View /> : <Text style={{ color: textColor, fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(7), textAlign: "center" }}>{i18n.t("levels." + user.children_level).toLocaleLowerCase()}</Text>;
        return <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
            <Text style={{ color: textColor, fontFamily: appTheme.superHerosFontBold, fontSize: appTheme.pixelPerfectForFont(9), textAlign: "center" }}>{titleToDisplay.replace("\\n", "\n")}</Text>
            {levelTitle}
        </View>
    }

    const getRightButton = () => {
        let rightButtonsView: React.JSX.Element[] = [];
        if ((tips !== undefined) && (tips[sectionkey] !== undefined)) {
            rightButtonsView.push(<TipsButton color={"#FFFFFF"} style={{ marginEnd: appTheme.pixelPerfect(10) }} tips={tips[sectionkey]} />);
        }
        if (showLevel === true) {
            rightButtonsView.push(<LevelsButton />);
        }
        return rightButtonsView;
    }



    return <View style={[categoryHomeStyle.navigationBar(navBarColor)]}>
        <View style={categoryHomeStyle.navigationBarContent}>
            {getLeftButton()}
            {renderTitle()}
            {getRightButton()}
        </View>
    </View>

}

export default NavBar;